import {Q} from '@nozbe/watermelondb';
import {database} from '..';
import {BUSINESS_SCHEMA, ACCOUNT_SCHEMA} from '../schema';

const business = database.collections.get(BUSINESS_SCHEMA);

export const findBusinessByID = async id => await business.find(id);

export const getBusinessByAccId = accId => business.query(Q.on(ACCOUNT_SCHEMA, 'id', accId), Q.where('archive', Q.notEq(true))).observe();
